
export const setLogin = (user) => ({
  type: 'LOGIN',
  user
});

export const setLogout = () => ({
  type: 'LOGOUT'
});
